const iceCandidates: any = [];

// 从候选信息中提取 IP 地址的函数
const extractIPs = (candidateStr: string) => {
  // IP 地址正则表达式
  var ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
  // 使用正则表达式匹配 IP 地址
  var matches = candidateStr.match(ipRegex);
  return matches || [];
};

const resolveHandler = (candidate: string, icecandidateStatus: any, resolve: any, peer:any) => {
  const ips = extractIPs(candidate);
  const clear = (ip = '') => {
    if (icecandidateStatus.defer) {
      clearTimeout(icecandidateStatus.defer);
      icecandidateStatus.defer = null;
    }
    icecandidateStatus.status = '';
    peer.close();
    resolve(ip);
  };
  if (Array.isArray(ips) && ips.length > 0) {
    ips.forEach((ip: string) => {
      if (ip !== '0.0.0.0') {
        // callback(ip);
        clear(ip);
      }
    });
  } else if (icecandidateStatus.status === 'PENDING') {
    clear('');
  } else {
    icecandidateStatus.status = 'PENDING';
    if (!icecandidateStatus.defer) {
      icecandidateStatus.defer = setTimeout(() => {
        if (icecandidateStatus.status === 'PENDING') {
          clear('');
        }
      }, 5000);
    }
  }
};

export const createRTCPeerConnection = () => {
  // status 处理 第一次onicecandidate接收到的candidate中没有ip 从第二次开始如果还没有IP 直接resolve('')  defer 解决如果没有第二次则5s后直接触发 resolve('')
  const icecandidateStatus = { status: '', defer: null };
  return new Promise(resolve => {
    try {
      // eslint-disable-next-line
      // @ts-ignore
      const peerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;

      if (peerConnection) {
        // 创建 PeerConnection 对象，使用 小米 的 STUN 服务器
        const peer = new peerConnection({ iceServers: [{ urls: 'stun:stun.miwifi.com' }] });
        // 创建一个数据通道以触发 ICE 候选的收集
        peer.createDataChannel('');

        peer.createOffer().then(function(sdp: any) {
          // 将 sdp 中的 ICE 候选信息分割并存储
          sdp.sdp.split('\n').forEach(function(line: any) {
            if (line.indexOf('candidate') < 0) return;
            iceCandidates.push(line);
          });
          peer.setLocalDescription(sdp);
        }).catch(function(error) {
          console.error('Error creating offer:', error);
        });

        // 监听 onicecandidate 事件以收集 ICE 候选信息
        peer.onicecandidate = function(event) {
          if (event.candidate) {
            iceCandidates.push(event.candidate.candidate);
            resolveHandler(event.candidate.candidate, icecandidateStatus, resolve, peer);
          } else {
            // 所有 ICE 候选已收集，开始处理它们
            if (Array.isArray(iceCandidates) && iceCandidates.length > 0) {
              iceCandidates.forEach(function(candidate: string) {
                resolveHandler(candidate, icecandidateStatus, resolve, peer);
              });
            } else {
              resolve('');
            }
          }
        };
      } else {
        resolve('');
      }
    } catch  {
      resolve('');
    }
  });
};
